import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  query,
  where,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from './firebase';

const COLLECTION = 'eventTemplates';

export const saveTemplate = async (organizationId, name, templateData, createdBy) => {
  const ref = await addDoc(collection(db, COLLECTION), {
    organizationId,
    name,
    createdBy,
    createdAt: serverTimestamp(),
    // Event fields (no date/recurrence — those are per-event)
    title: templateData.title || '',
    description: templateData.description || '',
    location: templateData.location || '',
    startTime: templateData.startTime || '',
    endTime: templateData.endTime || '',
    volunteersNeeded: Number(templateData.volunteersNeeded) || 1,
    assignments: (templateData.assignments || []).map((a) => ({
      name: a.name || '',
      description: a.description || '',
      volunteersNeeded: Number(a.volunteersNeeded) || 1,
      startTime: a.startTime || '',
      endTime: a.endTime || '',
    })),
  });
  return ref.id;
};

export const getTemplates = async (organizationId) => {
  const q = query(collection(db, COLLECTION), where('organizationId', '==', organizationId));
  const snapshot = await getDocs(q);
  const templates = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
  templates.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  return templates;
};

export const deleteTemplate = async (templateId) => {
  await deleteDoc(doc(db, COLLECTION, templateId));
};
